module.exports = __webpack_public_path__ + "static/media/main-board.d9a23c3b.png";